export default "__VITE_ASSET__CUtOUPVE__"